import { Button, Grid, Tab, Text } from '@wework/dieter-ui'
import Row from '../../Common/Row'
import React, { useEffect, useState } from 'react'
import Linkeable from './Linkeable'
import LinkeableDeskReservable from './LinkeableDeskReservable'
import LinkPreview from './LinkPreview'
import { withSnackbar } from '../../../hoc/SnackBarProvider'
import * as _ from 'lodash'
import { withFloorMap } from '@wework/react-floormap'
import DeskLinkeageHeader from './DeskLinkeageHeader'
import HoldNotice from './HoldNotice'
import LoadingPlaceholder from '../../Misc/LoadingPlaceholder'
import { useSidebar } from '../../../hoc/withSidebar'

function DeskLinkeage({ floorMap, spaces, snackBars, multiDeskSetter }) {
  const [loading, setLoading] = useState(false)
  const { closeSideBar } = useSidebar()
  const [spacesLinkage, setSpacesLinkeage] = useState<any>(new Map())
  const getLinkingText = () => {
    return `Select desk inventory item to link to this physical object so the map shows the right inventory.`
  }

  useEffect(() => {
    const newLinkeage = spacesLinkage
    spaces.map(space => {
      if (!newLinkeage?.get(space.uuid)) {
        newLinkeage.set(space.uuid, space.reservable)
      }
    })
    setSpacesLinkeage(newLinkeage)
    return () => {
      setSpacesLinkeage(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaces])

  const assignSystemIdToSpace = () => {
    return new Promise((resolve, reject) => {
      const floor = spaces[0].floorUUID
      spaces.forEach(space => {
        if (
          !space.reservable ||
          space.reservable?.uuid !== spacesLinkage.get(space?.uuid)?.uuid
        ) {
          floorMap.extensions.classification
            .assignSystemUUIDToSingleSpace(
              floor,
              spacesLinkage.get(space?.uuid)?.uuid || '',
              space
            )
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    })
  }

  const refreshReservableAndBuildingIndex = async () => {
    const reservableExtension = floorMap.extensions.reservable
    const inventoryExt = floorMap.getExtension('inventoryData')

    if (!reservableExtension) {
      return
    }

    const currentBuilding = floorMap.getCurrentBuilding()
    const currentFloor = floorMap.getCurrentFloor()
    const buildingUUID = _.get(currentBuilding, 'systemUUID')

    if (!buildingUUID) {
      return
    }

    const fetchBuildingIndex = _.get(
      floorMap,
      'extensions.buildingIndex.fetchBuildingIndex',
      () => {}
    )

    await Promise.all([
      reservableExtension.fetchOccupancies(buildingUUID),
      fetchBuildingIndex(currentBuilding.uuid),
      inventoryExt.getInventory(currentFloor.uuid, true),
    ])

    return
  }

  const onLink = async () => {
    setLoading(true)
    const reservableExtension = floorMap.extensions.reservable

    try {
      await assignSystemIdToSpace()
    } catch (err) {
      console.error(err)
      setLoading(false)
      snackBars.addAlert({
        text: `Ops! Something went wrong, please try again.`,
        variant: 'failed',
      })

      return
    }
    try {
      await refreshReservableAndBuildingIndex()
      // update the room data
      spaces.forEach(space => {
        floorMap.updateData(space.uuid)
      })

      floorMap.extensions.BASE_STYLE_EXTENSION.reload()
      reservableExtension.reloadMapStyles()
    } catch (e) {
      setLoading(false)
      // setShowReloadDialog(true)
    }
    setLoading(false)
    closeSideBar()
    snackBars.addAlert({
      text: `Linkage updated successfuly!`,
      variant: 'success',
    })
  }

  const getLinkeageContent = (unlinked = false) => {
    return (
      <>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Text
                style={{
                  fontWeight: 'bold',

                  marginBottom: 8,
                }}
                size="small"
              >
                Physical entity
              </Text>
            </Grid.Column>
            <Grid.Column>
              <Text
                style={{
                  fontWeight: 'bold',

                  marginBottom: 8,
                }}
                size="small"
              >
                Inventory
              </Text>
            </Grid.Column>
            <Grid.Column></Grid.Column>
          </Grid.Row>

          {spaces.map((space, index) => {
            if (unlinked && space.reservable) {
              return
            }
            return (
              <>
                {index > 0 && (
                  <svg width="16" height="16" style={{ alignSelf: 'center' }}>
                    <line x1="8" y1="16" x2="8" y2="0" stroke="#B0B0B0" />
                  </svg>
                )}
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <Linkeable space={space} />
                  </Grid.Column>
                  <Grid.Column>
                    <LinkeableDeskReservable
                      floorMap={floorMap}
                      spaceLinked={spacesLinkage.get(space.uuid)}
                      setSpaceLinked={selected => {
                        setSpacesLinkeage(
                          map => new Map(map.set(space.uuid, selected))
                        )
                      }}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    {/* <LinkeableDeskReservable
                    floorMap={floorMap}
                    spaceLinked={spacesLinkage.get(space.uuid)}
                    setSpaceLinked={selected => {
                      spacesLinkage.set(space.uuid, selected)
                      setSpacesLinkeage(spacesLinkage)
                    }}
                  /> */}
                    <LinkPreview space={spacesLinkage.get(space.uuid)} />
                  </Grid.Column>
                </Grid.Row>
              </>
            )
          })}
        </Grid>
      </>
    )
  }

  const panes = [
    {
      menuItem: 'All',
      render: () => (
        <Tab.Pane attached={false}>{getLinkeageContent(false)}</Tab.Pane>
      ),
    },
    {
      menuItem: 'Not linked',
      render: () => (
        <Tab.Pane attached={false}>{getLinkeageContent(true)}</Tab.Pane>
      ),
    },
  ]

  const hasReservation = spaces.filter(space => Boolean(space.reservable))
  if (loading) return <LoadingPlaceholder text="Saving Linkage" />
  return (
    <>
      <DeskLinkeageHeader spaces={spaces} multiDeskSetter={multiDeskSetter} />

      {/* {spaces.length === 1 && <HoldNotice space={spaceLinked} />} */}
      <div style={{ marginTop: 44 }}>
        <Text size="small">{getLinkingText()}</Text>
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />

        {/* <Row
          style={{
            position: 'relative',
            marginTop: 24,
            marginBottom: 16,
            alignItems: 'flex-start',
          }}
        >
          {spaceLinked && (
            <div style={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
              <LinkPreview space={spaceLinked} />
            </div>
          )}
        </Row> */}
        <Row>
          <Text
            primary
            size="small"
            onClick={() => {
              snackBars.addAlert({
                text: `You can select multiple desks now`,
                variant: 'info',
              })
              multiDeskSetter(true)
            }}
            style={{ cursor: 'pointer', marginTop: 24 }}
          >
            Link multiple desks
          </Text>
        </Row>
      </div>
      <Row style={{ marginTop: 'auto' }}>
        {hasReservation.length > 0 && (
          <Text size="small">
            ⚠️ This will overwrite exisiting linked inventory.
          </Text>
        )}
        <div style={{ marginLeft: 'auto' }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              closeSideBar()
              multiDeskSetter(false)
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            primary
            size="small"
            onClick={() => {
              multiDeskSetter(false)
              onLink()
            }}
            style={{ marginLeft: 12 }}
          >
            Save
          </Button>
        </div>
      </Row>
    </>
  )
}

export default withSnackbar(withFloorMap()(DeskLinkeage))
